<template>
    <v-tooltip bottom v-if="latest">
        <template #activator="{ on, attrs }">
            <v-chip
                v-bind="attrs"
                v-on="on"
                small
                color="orange darken-2"
                text-color="white"
                class="mr-2 dual-swipe-chip"
                @click="$store.state.Notification_drawer = true"
            >
                <v-icon left x-small>mdi-clock-alert-outline</v-icon>
                <span class="font-weight-bold">{{ hoursWorked || '00:00' }}</span>
            </v-chip>
        </template>
        <div style="max-width:240px">
            <div class="font-weight-bold">{{ latest.title }}</div>
            <div class="caption">{{ latest.description }}</div>
        </div>
    </v-tooltip>
</template>

<script>
const TITLE_PREFIX = 'Attendance: missing'

export default {
    name: 'DualSwipeAlert',
    data: () => ({
        timer: null,
    }),
    computed: {
        // Latest unread "missing IN/OUT" notification from today, or null.
        latest() {
            const list = this.$store.state.Notifications || []
            const today = new Date().toISOString().slice(0, 10)
            return list.find(n =>
                !n.read_status
                && (n.title || '').startsWith(TITLE_PREFIX)
                && (n.datetime || '').startsWith(today)
            ) || null
        },
        // Pull "Hours worked so far: HH:MM" out of the description for the chip.
        hoursWorked() {
            if (!this.latest || !this.latest.description) return null
            const m = this.latest.description.match(/Hours worked so far:\s*(\d{1,2}:\d{2})/)
            return m ? m[1] : null
        },
    },
    mounted() {
        this.refresh()
        document.addEventListener('visibilitychange', this.onVisibility)
        this.startTimer()
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.onVisibility)
        this.stopTimer()
    },
    methods: {
        onVisibility() {
            if (document.visibilityState === 'visible') {
                this.refresh()
                this.startTimer()
            } else {
                this.stopTimer()
            }
        },
        startTimer() {
            this.stopTimer()
            this.timer = setInterval(() => {
                if (document.visibilityState === 'visible') this.refresh()
            }, 30000)
        },
        stopTimer() {
            if (this.timer) { clearInterval(this.timer); this.timer = null }
        },
        refresh() {
            // Reuse the existing notifications endpoint; populates Vuex store
            // that NotificationsSideBar also reads.
            this.$axios.get('/api/notifications/index').then(resp => {
                this.$store.state.Notifications = resp.data
            }).catch(() => {})
        },
    },
}
</script>

<style scoped>
.dual-swipe-chip {
    animation: dual-swipe-pulse 2s ease-in-out infinite;
}
@keyframes dual-swipe-pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(245, 124, 0, 0.6); }
    50%      { box-shadow: 0 0 0 6px rgba(245, 124, 0, 0); }
}
</style>
